module.exports = __webpack_public_path__ + "img/4_1.4d0e5440.jpg";